import * as React from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { request } from "../../../services/cpln";
import { Loader } from "../../layout/loader";
import { Command } from "../../../schema/types/command";
import { BasePathContext } from "../../../reactContexts/basePathContext";
import { SyntaxHighlight } from "../../syntaxHighlight/SyntaxHighlight";
import { CommandActions } from "./commandActions";
import { LeftOutlined, SyncOutlined } from "@ant-design/icons";
import { Alert, Button } from "antd";

type RouteParams = "commandId";
interface Props {
  itemLink: string;
  containerName?: string;
}
export const CommandDetail: React.FC<Props> = ({ itemLink, containerName }) => {
  const { commandId } = useParams<RouteParams>();
  const [searchParams] = useSearchParams();
  const fromExecutions = searchParams.get("fromExecutions");

  const navigate = useNavigate();
  const basePath = React.useContext(BasePathContext);

  const [isLoading, setIsLoading] = React.useState(true);
  const [command, setCommand] = React.useState<Command>(null as any);

  React.useEffect(() => {
    fetchCommand();
  }, []);

  async function fetchCommand() {
    try {
      setIsLoading(true);
      const { data } = await request({ url: `${itemLink}/-command/${commandId}` });
      setCommand(data);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  }

  if (isLoading) {
    return <Loader fullScreen />;
  }

  return (
    <>
      <div className="flex items-center justify-between mb-4">
        {fromExecutions ? (
          <Button
            type={"text"}
            className="button-link flex items-center"
            onClick={() => navigate(`${basePath}/job-executions`)}
            icon={<LeftOutlined />}
            iconPosition="start"
          >
            Back to Job Executions
          </Button>
        ) : (
          <Button
            type={"text"}
            className="button-link flex items-center"
            onClick={() => navigate(`${basePath}/commands`)}
            icon={<LeftOutlined />}
            iconPosition="start"
          >
            Back to Commands
          </Button>
        )}
        <Button
          type="default"
          icon={<SyncOutlined />}
          iconPosition="end"
          onClick={fetchCommand}
          loading={isLoading}
          disabled={isLoading}
        >
          Refresh
        </Button>
      </div>
      {command ? (
        <>
          <CommandActions command={command} containerName={containerName} />
          <SyntaxHighlight
            code={JSON.stringify(command, null, 2)}
            language="json"
          />
        </>
      ) : null}
      {command ? null : <Alert showIcon type="error" message="Command is not found" />}
    </>
  );
};
